"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var NotificationCard = /** @class */ (function (_super) {
    __extends(NotificationCard, _super);
    function NotificationCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localeChanged = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    NotificationCard.prototype.componentDidMount = function () {
        LocaleProvider_1.default.on(this.localeChanged);
    };
    NotificationCard.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.localeChanged);
    };
    NotificationCard.prototype.render = function () {
        // tslint:disable-next-line:max-line-length
        var _a = this.props, author = _a.author, authorLink = _a.authorLink, actions = _a.actions, badge = _a.badge, className = _a.className, children = _a.children, date = _a.date, onAuthorClick = _a.onAuthorClick, onTitleClick = _a.onTitleClick, validity = _a.validity, title = _a.title;
        var b = config_1.block("notification_card");
        var localization = LocaleProvider_1.default.locs.notification_card;
        return (react_1.default.createElement("div", { className: b({}).mix(className) },
            react_1.default.createElement("div", { className: b("header") },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h4", { className: b("header__title"), onClick: onTitleClick }, title),
                    validity && (react_1.default.createElement(react_1.default.Fragment, null,
                        "\u00A0",
                        react_1.default.createElement("span", { className: b("header__valid") },
                            localization.validity,
                            "\u00A0",
                            validity)))),
                react_1.default.createElement("div", null, badge)),
            react_1.default.createElement("div", { className: b("content") }, children),
            react_1.default.createElement("div", { className: b("footer") },
                react_1.default.createElement("div", { className: b("actions") }, actions.map(function (action, index) { return (react_1.default.createElement("div", { className: b("actions__item"), key: "action-" + index }, action)); })),
                react_1.default.createElement("div", null,
                    localization.sended,
                    "\u00A0",
                    react_1.default.createElement("a", { className: b("author"), href: authorLink || "#", onClick: onAuthorClick }, author),
                    "\u00A0",
                    date))));
    };
    return NotificationCard;
}(react_1.default.Component));
exports.default = NotificationCard;
//# sourceMappingURL=index.js.map